export const FALLBACK_BANNER = 'https://static.cinuru.com/public/dashboard/placeholder.jpg';

// the zIndex of material-uis Modal is 1300 by default
export const POPPER_ZINDEX = 2000;
export const HEADER_BAR_ZINDEX = 1000;
